import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import clinicService from "../../../../../services/clinic.service";

import clinicbookingService from "../../../../../services/clinicbooking.service";

function AddDoctorInfo() {
  const [clinicDoctors, setClinicDoctors] = useState([]); //used for userId

  const { clinicId } = useParams();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();
  useEffect(() => {
    //get list of clinic Doctors for Drop Down
    getClinicDoctors();
  }, []);

  const getClinicDoctors = () => {
    clinicService
      .getUsers(clinicId)
      .then((res) => {
        setClinicDoctors(res.data);
       
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onSubmit = (data) => {
    const newData = { ...data, clinicId: clinicId };
    //console.log(newData)
    clinicbookingService
      .addUpdateDoctor(clinicId, newData)
      .then((res) => {
        console.log("Response Data");
        console.log(res.data);
        toast.success("Updated Doctor", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)} className="m-2">
      <div className="row mb-3">
        <div className="col-5">
          <label htmlFor="userId" className="form-label">
            Doctor{" "}
          </label>
          <select
            className="form-select form-select-sm me-2"
            {...register("userId")}
          >
            {clinicDoctors &&
              clinicDoctors.map((doc) => (
                <option key={doc.id} value={doc.id}>
                  {doc.firstName} {doc.lastName}
                </option>
              ))}
          </select>
          <input type="hidden" {...register("clinicId")} />
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-5">
          <label htmlFor="displayname" className="form-label">
            Display Name
          </label>
          <input type="text" className="form-control" {...register("name")} />
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-5">
          <label htmlFor="photourl">Photo Url:</label>
          <input
            type="text"
            className="form-control"
            {...register("photo_url")}
          />
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-5">
          <label htmlFor="isActive">Status</label>
          <select
            className="form-select form-select-sm me-2"
            {...register("isActive")}
          >
            <option value="1">Active</option>
            <option value="0">Inactive</option>
          </select>
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-5">
          <label htmlFor="bio">Bio</label>
          <textarea
            type="text"
            className="form-control"
            {...register("bio")}
          ></textarea>
        </div>
      </div>
      <button className="btn btn-sm btn-success me-3" type="submit">
        <i className="bi bi-floppy"></i> Add New
      </button>
    </form>
  );
}

export default AddDoctorInfo;
